module.exports = __webpack_public_path__ + "static/media/DPL_04.da26ea51.jpg";